module.exports = __webpack_public_path__ + "static/media/apple-touch-startup-image-828x1792.a1313088.png";